/**
 * Valida se o número passado é uma linha telefônica brasileira válida.
 * Aceita DDDs de 11 a 99, seguido de 8 ou 9 dígitos após o DDD (10 ou 11 dígitos no total).
 * - Números móveis (11 dígitos): [DDD][9][restante]
 * - Números fixos (10 dígitos): [DDD][2-5 ou 7-8][restante]
 */
export function validatePhoneNumber(phone: string): boolean {
  if (!phone || !/^\d{10,11}$/.test(phone)) return false;

  const ddd = parseInt(phone.substring(0, 2), 10);

  if (ddd < 11 || ddd > 99) return false;

  if (phone.length === 11) {
    // Móvel: 9xxxxxxxx
    return phone[2] === "9";
  }

  if (phone.length === 10) {
    // Fixo: 2x..., 3x..., 4x..., 5x..., 7x..., 8x...
    const firstDigit = parseInt(phone[2], 10);

    return [2, 3, 4, 5, 7, 8].includes(firstDigit);
  }

  return false;
}
